import { isFunction, isDate, isRegExp, isBoolean } from './util_10_lang'; // from underscore

// 转义
export function escapeRegExp(str) {
  return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
}
/**
* 替换所有文本
* @param {string} str 初始文本
* @param {string} search 被替换的文本
* @param {string} replace 替换为的文本
* @param {boolean} escape 是否需要转义
* @return {string} 替换后的文本
* @memberof module:string
* @example
* imutils.replaceAll(str, search, replace, escape)
*/

export function replaceAll(str, search, replace) {
  var escape = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (escape) {
    return str.replace(new RegExp(escapeRegExp(search), 'g'), replace);
  }

  return str.replace(new RegExp(search, 'g'), replace);
} // 驼峰与下划线转换
// https://www.npmjs.com/package/humps
//---------------------------------------------------

function processKeys(convert, obj, options) {
  if (obj !== Object(obj) || isDate(obj) || isRegExp(obj) || isBoolean(obj) || isFunction(obj)) {
    return obj;
  }

  var output;
  var i = 0;
  var l = 0;

  if (Array.isArray(obj)) {
    output = [];

    for (l = obj.length; i < l; i++) {
      output.push(processKeys(convert, obj[i], options));
    }
  } else {
    output = {};
    Object.keys(obj).forEach(function (item) {
      output[convert(item, options)] = processKeys(convert, obj[item], options);
    });
  }

  return output;
}
/**
* 替换所有文本
* @param {string} string 初始文本
* @param {object} options 被替换的文本 属性为separator(默认为_) split
* @return {string} 替换后的文本
* @memberof module:string
* @example
* imutils.separateWords(str,{separator:'-',split:'a'})
*/


export function separateWords(string, options) {
  options = options || {};
  var separator = options.separator || '_';
  var split = options.split || /(?=[A-Z])/;
  return string.split(split).join(separator);
} // Sets up function which handles processing keys
// allowing the convert function to be modified by a callback

function processor(convert, options) {
  var callback = options && 'process' in options ? options.process : options;

  if (typeof callback !== 'function') {
    return convert;
  }

  return function (string) {
    return callback(string, convert, options);
  };
}
/**
* 转为驼峰格式
* @param {string} string 初始文本
* @param {boolean} firstUpperCase 首字母大写，默认为false
* @return {string} 转换后的文本
* @memberof module:string
*/


export function camelize(string) {
  var firstUpperCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (typeof string === 'number') {
    // 如果是数字直接返回
    return string;
  }

  string = string.replace(/[-_\s]+(.)?/g, function (match, chr) {
    return chr ? chr.toUpperCase() : '';
  }); // 首字母小写

  if (!firstUpperCase) {
    return string.substr(0, 1).toLowerCase() + string.substr(1);
  } // 首字母大写


  return string.substr(0, 1).toUpperCase() + string.substr(1);
}
/**
* @param {string} string 初始文本
* @param {boolean} firstUpperCase 首字母大写，默认为false
* @return {string} 转换后的文本
* @memberof module:string
*/

export function decamelize(string, options) {
  return separateWords(string, options).toLowerCase();
}
/**
* @param {string} string 初始文本
* @param {boolean} firstUpperCase 首字母大写，默认为false
* @return {string} 转换后的文本
* @memberof module:string
* @example
* camelizeKeys({ a: 1, b: 2 }, { process() { return 'a'; } }) => { a: 2 }
*/

export function camelizeKeys(object, options) {
  return processKeys(processor(camelize, options), object);
}
/**
* @param {string} string 初始文本
* @param {boolean} firstUpperCase 首字母大写，默认为false
* @return {string} 转换后的文本
* @memberof module:string
* @example
* decamelizeKeys({ a: 1, b: 2 }, { process() { return 'a'; } }) => { a: 2 }
*/

export function decamelizeKeys(object, options) {
  return processKeys(processor(decamelize, options), object, options);
}
/**
* 删除小数尾部的0
* @param {string} raw 初始文本 10.020
* @return {string} 转换后的文本
* @memberof module:string
* @example
* decamelizeKeys(10.020) => 10.02
* 备注：parseFloat虽然可实现该功能，但有精度问题，比如 parseFloat("1212121212121212.33")//1212121212121212.2
*/

export function removeTailZero() {
  var raw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var str = '';

  if (raw !== null) {
    str = raw.toString();
  }

  if (str.indexOf('.') < 0) {
    // 不是小数的情况
    return str;
  }

  var strArr = str.split('');

  for (var i = strArr.length - 1; i >= 0; i--) {
    if (strArr[i] >= '1' && strArr[i] <= '9') {
      break;
    } else if (strArr[i] === '.') {
      strArr.splice(i, 1);
      break;
    } else {
      strArr.splice(i, 1);
    }
  }

  return strArr.join('');
}